export default __webpack_public_path__ + "static/squareGif-94e1822e777b1ca510ea371740a45975.gif";